$(document).on('turbolinks:load', function() {
  $('.classroom-payment-types .card').click(function () {
    $('.classroom-payment-types > .row').children().each(function(_i, v) { v.classList.remove('selected') });
    $(this).addClass('selected');
    $(this).children().find('input').prop('checked', true);
  });
});
